var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVisibility = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.99,
    height: 12.087,
    viewBox: "0 0 13.99 12.087",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_visibility_off_24px",
    d: "M8,5.545a3.182,3.182,0,0,1,3.181,3.181A3.088,3.088,0,0,1,10.95,9.89l1.858,1.858A7.518,7.518,0,0,0,14.99,8.726a7.524,7.524,0,0,0-7-4.771A7.409,7.409,0,0,0,5.46,4.4L6.834,5.774A3.088,3.088,0,0,1,8,5.545ZM1.636,3.808,3.087,5.258l.293.293A7.51,7.51,0,0,0,1,8.726a7.521,7.521,0,0,0,9.785,4.237l.267.267,1.864,1.858.808-.808L2.444,3ZM5.154,7.326l.986.986a1.8,1.8,0,0,0-.051.414A1.906,1.906,0,0,0,8,10.634a1.8,1.8,0,0,0,.414-.051l.986.986A3.16,3.16,0,0,1,5.154,7.326ZM7.9,6.83l2,2,.013-.1A1.906,1.906,0,0,0,8,6.823Z",
    transform: "translate(-1 -3)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVisibility);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-visibility.8711c6e5b6c455d149331b2836eece8d.svg";